// import { Link } from "gatsby"
import React, { memo, useEffect } from "react"
// import * as style from "./linkButtonRed.module.css"
import AOS from "aos"
import "aos/dist/aos.css"
import { appNavigate } from "../../../utils/functions"
import LinkArrow from "../../svg/new/LinkArrow"

const LinkButtonRed = ({
  btnText,
  target,
  CustomBtnClass,
  linkTo,
  click,
  aosType,
  aosDelay,
}) => {
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  return (
    <a
      href={linkTo}
      onClick={e => {
        e.preventDefault()
        appNavigate(linkTo)
        click?.()
      }}
      target={target === "_blank" ? "_blank" : "_self"}
      className={`link_btn  ${CustomBtnClass}`}
      data-aos={aosType}
      data-aos-delay={aosDelay}
    >
      <div>{btnText}</div>
      <i>
        <LinkArrow />
      </i>
    </a>
  )
}

export default memo(LinkButtonRed)
